import { render } from "./importleads.vue?vue&type=template&id=53558a1c"
import script from "./importleads.vue?vue&type=script&lang=js"
export * from "./importleads.vue?vue&type=script&lang=js"

import "./importleads.vue?vue&type=style&index=0&id=53558a1c&lang=scss"

import exportComponent from "/Users/arvindersingh/Desktop/projects/parsoftwares/rt-backend/backend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__